<template>
  <div class="card-container">
    <div class="card-container-item">

      <v-card shaped class="instruction-card">
        <div class="instructions-container">
          <div class="instruction">
            <div class="instruction-icon white--text">
              <v-icon color="white" size="100">mdi-rotate-orbit</v-icon>
            </div>
            <div class="instruction-text white--text">
              <h3>Click and drag to look around</h3>
            </div>
          </div>

          <div class="instruction">
            <div class="instruction-icon">
              <v-icon color="white" size="80">mdi-mouse-scroll-wheel</v-icon>
            </div>
            <div class="instruction-text white--text">
              <h3>Scroll to zoom</h3>
            </div>
          </div>
        </div>
      </v-card>

    </div>
  </div>
</template>

<script>

export default {
  name: "PanoramaInstructions",
  props: [],
  data: () => ({}),
};
</script>

<style scoped>
.card-container {
  width: 100%;
  height: calc(100% - 112px);
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-container-item {
  justify-content: center;
  align-items: center;
  display: flex;
  flex-grow: 0;
}

.instructions-container {
  display: flex;
}

.instruction {
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: center;
  align-items: center;
}

.instruction-icon {
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
}

.instruction-text {
  text-align: center;
  max-height: 3.5rem;
  flex: 1;
}

.instruction-card {
  justify-content: center;
  align-items: center;
  display: flex;
  background-color: rgba(0, 0, 0, 0.5) !important;
  pointer-events: none;
  padding: 10px;
}
</style>